export const getCurrentUrl = (
  locale: string,
  domain: string,
  asPath: string,
) => {
  return `https://${process.env.NEXT_PUBLIC_BASE_URL}/${locale}${asPath}`;
};
